const PROGRESS_STORAGE_KEY = "pathimo-progress-v1";

export function readSavedProgress() {
  try {
    const rawValue = window.localStorage.getItem(PROGRESS_STORAGE_KEY);
    if (!rawValue) {
      return null;
    }

    const parsed = JSON.parse(rawValue);
    if (!parsed || typeof parsed !== "object") {
      return null;
    }

    if (!Number.isInteger(parsed.levelNumber) || parsed.levelNumber < 1) {
      return null;
    }

    if (!parsed.board || !Array.isArray(parsed.board.paths)) {
      return null;
    }

    return parsed;
  } catch (error) {
    console.error("Could not read saved progress.", error);
    return null;
  }
}

export function writeSavedProgress(progress) {
  try {
    window.localStorage.setItem(PROGRESS_STORAGE_KEY, JSON.stringify(progress));
  } catch (error) {
    console.error("Could not save progress.", error);
  }
}
